//app/javascript/application.js
// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "trix"
import "@rails/actiontext"
// AdminLTE (must be after Bootstrap)
import "./theme"
import "./controllers"
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()